import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const SITE_ORIGIN = "https://stoneagelandscapes.com";
const DEFAULT_TITLE = "Stone Age Landscapes | Built to Last";
const DEFAULT_DESCRIPTION =
  "Stone Age Landscapes provides landscaping, excavation, and snow management services across Maple Grove and surrounding Minneapolis suburbs.";

function upsertMetaTag(key, content, attribute = "name") {
  if (!content) return;

  let tag = document.head.querySelector(`meta[${attribute}='${key}']`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
}

function upsertCanonicalUrl(href) {
  if (!href) return;

  let canonical = document.head.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute("href", href);
}

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Stone Age Landscapes | Landscaping and Snow Services",
      description:
        "Stone Age Landscapes delivers premium landscaping, excavation, and dependable snow management services in Maple Grove and nearby communities.",
    },
  },
  {
    path: "/gallery",
    name: "gallery",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "gallery" */ "../views/GalleryView.vue"),
    meta: {
      title: "Project Gallery | Stone Age Landscapes",
      description:
        "Browse Stone Age Landscapes project photos featuring landscaping, hardscaping, excavation, and seasonal outdoor transformations.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.afterEach((to) => {
  const title = to.meta?.title || DEFAULT_TITLE;
  const description = to.meta?.description || DEFAULT_DESCRIPTION;

  document.title = title;
  upsertMetaTag("description", description);
  upsertMetaTag("og:title", title, "property");
  upsertMetaTag("og:description", description, "property");
  upsertMetaTag("og:type", "website", "property");

  const canonicalUrl = new URL(to.fullPath || to.path || "/", SITE_ORIGIN);
  upsertCanonicalUrl(canonicalUrl.href);
  upsertMetaTag("og:url", canonicalUrl.href, "property");
});

export default router;
